(function () {
  'use strict';

  const ZOOM = 2.5;

  function initGallery(galleryEl) {
    if (galleryEl.dataset.gfsReady) return;
    galleryEl.dataset.gfsReady = '1';

    galleryEl.addEventListener('click', function (e) {
      // Only image slides
      const slide = e.target.closest('.swiper-slide[data-media-type="image"]');
      if (!slide || slide.classList.contains('swiper-slide-duplicate')) return;

      const img = slide.querySelector('img');
      if (!img) return;

      // If already zoomed → close (unless el click viene de un drag)
      if (slide.classList.contains('gfs-zoomed')) {
        if (slide._gfsDragOccurred) return;
        closeZoom(slide, img);
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      openZoom(slide, img, e);
    }, true);
  }

  function openZoom(slide, img, e) {
    const rect = img.getBoundingClientRect();
    const offsetX = e.clientX - rect.left;
    const offsetY = e.clientY - rect.top;

    // Origin as percentage
    const originX = (offsetX / rect.width) * 100;
    const originY = (offsetY / rect.height) * 100;

    img.style.transformOrigin = `${originX}% ${originY}%`;
    img.style.transform = `scale(${ZOOM})`;
    img.style.transition = 'transform 0.3s ease';

    slide.classList.add('gfs-zoomed');

    // Bloquear el swipe del slider mientras hay zoom
    const swiperEl = slide.closest('.swiper');
    if (swiperEl && swiperEl.swiper) {
      const sw = swiperEl.swiper;
      sw.allowTouchMove = false;
      sw.allowSlideNext = false;
      sw.allowSlidePrev = false;
    }
    // Cortar propagación de todos los eventos de puntero para que Swiper no inicie el arrastre
    const blockPointer = (ev) => { ev.stopPropagation(); };
    slide._gfsBlockPointer = blockPointer;
    slide.addEventListener('pointerdown', blockPointer);
    slide.addEventListener('touchstart', blockPointer, { passive: true });
    slide.addEventListener('mousedown', blockPointer);

    if (window.matchMedia('(min-width: 1024px)').matches) {
      // Drag-to-pan: click+drag mueve la imagen
      let currentOriginX = originX;
      let currentOriginY = originY;

      img.style.cursor = 'grab';
      slide.style.cursor = 'grab';

      const onMouseDown = (ev) => {
        if (ev.button !== 0) return;

        let hasDragged = false;
        const startX = ev.clientX;
        const startY = ev.clientY;
        let lastX = ev.clientX;
        let lastY = ev.clientY;

        img.style.cursor = 'grabbing';
        slide.style.cursor = 'grabbing';
        img.style.transition = 'none';

        const onMouseMove = (ev) => {
          if (!hasDragged && (Math.abs(ev.clientX - startX) > 3 || Math.abs(ev.clientY - startY) > 3)) {
            hasDragged = true;
          }
          if (!hasDragged) return;

          const dx = ev.clientX - lastX;
          const dy = ev.clientY - lastY;
          lastX = ev.clientX;
          lastY = ev.clientY;

          const slideRect = slide.getBoundingClientRect();
          currentOriginX -= (dx / (ZOOM - 1)) / slideRect.width * 100;
          currentOriginY -= (dy / (ZOOM - 1)) / slideRect.height * 100;
          currentOriginX = Math.max(0, Math.min(100, currentOriginX));
          currentOriginY = Math.max(0, Math.min(100, currentOriginY));

          img.style.transformOrigin = `${currentOriginX}% ${currentOriginY}%`;
        };

        const onMouseUp = () => {
          document.removeEventListener('mousemove', onMouseMove);
          document.removeEventListener('mouseup', onMouseUp);
          img.style.cursor = 'grab';
          slide.style.cursor = 'grab';
          img.style.transition = 'transform 0.3s ease';

          if (hasDragged) {
            // Suprimir el click que dispara justo tras el mouseup
            slide._gfsDragOccurred = true;
            setTimeout(() => { delete slide._gfsDragOccurred; }, 0);
          }
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      };

      slide._gfsMouseDownHandler = onMouseDown;
      slide.addEventListener('mousedown', onMouseDown);

    } else {
      // Mobile: touch-drag-to-pan
      let touchCurrentOriginX = originX;
      let touchCurrentOriginY = originY;
      let touchStartX, touchStartY, touchLastX, touchLastY;
      let touchHasDragged = false;

      const onTouchStart = (ev) => {
        if (ev.touches.length !== 1) return;
        touchHasDragged = false;
        touchStartX = ev.touches[0].clientX;
        touchStartY = ev.touches[0].clientY;
        touchLastX = touchStartX;
        touchLastY = touchStartY;
        img.style.transition = 'none';
      };

      const onTouchMove = (ev) => {
        if (ev.touches.length !== 1) return;
        const touch = ev.touches[0];
        if (!touchHasDragged && (Math.abs(touch.clientX - touchStartX) > 5 || Math.abs(touch.clientY - touchStartY) > 5)) {
          touchHasDragged = true;
        }
        if (!touchHasDragged) return;
        ev.preventDefault();
        ev.stopPropagation();
        const dx = touch.clientX - touchLastX;
        const dy = touch.clientY - touchLastY;
        touchLastX = touch.clientX;
        touchLastY = touch.clientY;
        const slideRect = slide.getBoundingClientRect();
        touchCurrentOriginX -= (dx / (ZOOM - 1)) / slideRect.width * 100;
        touchCurrentOriginY -= (dy / (ZOOM - 1)) / slideRect.height * 100;
        touchCurrentOriginX = Math.max(0, Math.min(100, touchCurrentOriginX));
        touchCurrentOriginY = Math.max(0, Math.min(100, touchCurrentOriginY));
        img.style.transformOrigin = `${touchCurrentOriginX}% ${touchCurrentOriginY}%`;
      };

      const onTouchEnd = () => {
        img.style.transition = 'transform 0.3s ease';
        if (touchHasDragged) {
          slide._gfsDragOccurred = true;
          setTimeout(() => { delete slide._gfsDragOccurred; }, 0);
        }
      };

      slide._gfsTouchStartHandler = onTouchStart;
      slide._gfsTouchMoveHandler = onTouchMove;
      slide._gfsTouchEndHandler = onTouchEnd;
      slide.addEventListener('touchstart', onTouchStart, { passive: true });
      slide.addEventListener('touchmove', onTouchMove, { passive: false });
      slide.addEventListener('touchend', onTouchEnd);
    }
  }

  function closeZoom(slide, img) {
    img.style.transform = '';
    img.style.transformOrigin = '';
    img.style.transition = 'transform 0.3s ease';
    img.style.cursor = '';
    slide.style.cursor = '';
    slide.classList.remove('gfs-zoomed');

    // Reactivar el swipe del slider
    const swiperEl = slide.closest('.swiper');
    if (swiperEl && swiperEl.swiper) {
      const sw = swiperEl.swiper;
      sw.allowTouchMove = true;
      sw.allowSlideNext = true;
      sw.allowSlidePrev = true;
    }
    if (slide._gfsBlockPointer) {
      slide.removeEventListener('pointerdown', slide._gfsBlockPointer);
      slide.removeEventListener('touchstart', slide._gfsBlockPointer);
      slide.removeEventListener('mousedown', slide._gfsBlockPointer);
      delete slide._gfsBlockPointer;
    }

    if (slide._gfsMouseDownHandler) {
      slide.removeEventListener('mousedown', slide._gfsMouseDownHandler);
      delete slide._gfsMouseDownHandler;
    }

    if (slide._gfsTouchStartHandler) {
      slide.removeEventListener('touchstart', slide._gfsTouchStartHandler);
      slide.removeEventListener('touchmove', slide._gfsTouchMoveHandler);
      slide.removeEventListener('touchend', slide._gfsTouchEndHandler);
      delete slide._gfsTouchStartHandler;
      delete slide._gfsTouchMoveHandler;
      delete slide._gfsTouchEndHandler;
    }
  }

  function init() {
    document.querySelectorAll('.swiper--product-gallery').forEach(initGallery);
    document.querySelectorAll('.product-gallery-desktop').forEach(initDesktopGallery);
  }

  function initDesktopGallery(galleryEl) {
    if (galleryEl.dataset.gfsDesktopReady) return;
    galleryEl.dataset.gfsDesktopReady = '1';

    galleryEl.addEventListener('click', function (e) {
      const slide = e.target.closest('.product-gallery-desktop__slide');
      if (!slide) return;

      // Solo hacer zoom en el slide marcado como zoom-target (izquierdo/hero)
      if (!slide.classList.contains('is-zoom-target')) return;

      const img = slide.querySelector('img');
      if (!img) return;

      if (slide.classList.contains('gfs-zoomed')) {
        if (slide._gfsDragOccurred) return;
        closeZoom(slide, img);
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      openZoom(slide, img, e);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
